<!-- Orbe flotante -->
<button class="ai-orb" *ngIf="!open" (click)="toggle()" type="button" [attr.aria-label]="'Abrir asistente ' + companyName + ' AI'">
    <span class="ai-orb-spin"></span>
    <svg class="ai-sparkle" viewBox="0 0 24 24" width="24" height="24" fill="white" aria-hidden="true">
        <path d="M12 2l1.9 6.1L20 10l-6.1 1.9L12 18l-1.9-6.1L4 10l6.1-1.9L12 2z"/>
        <path d="M19 14l.9 2.6L22.5 17.5l-2.6.9L19 21l-.9-2.6-2.6-.9 2.6-.9L19 14z" opacity="0.85"/>
    </svg>
</button>

<!-- Panel de chat -->
<div class="ai-panel-frame" *ngIf="open" [class.ai-frame-thinking]="thinking">
    <span class="ai-frame-glow"><span class="ai-frame-spin"></span></span>
    <div class="ai-panel">

        <div class="ai-header">
            <div class="ai-title">
                <span class="ai-title-orb">
                    <svg viewBox="0 0 24 24" width="16" height="16" fill="white" aria-hidden="true">
                        <path d="M12 2l1.9 6.1L20 10l-6.1 1.9L12 18l-1.9-6.1L4 10l6.1-1.9L12 2z"/>
                    </svg>
                </span>
                <div class="ai-title-text">
                    <h3>{{ companyName }} AI</h3>
                    <span>Tu asistente del negocio</span>
                </div>
            </div>
            <div class="ai-head-actions">
                <button *ngIf="puedeUsarIa" class="ai-icon-btn" (click)="nuevaConversacion()" type="button" title="Nueva conversación" aria-label="Nueva conversación">
                    <i class="pi pi-plus"></i>
                </button>
                <button *ngIf="puedeUsarIa" class="ai-icon-btn" (click)="toggleHistory()" [class.active]="showHistory" type="button" title="Historial" aria-label="Historial">
                    <i class="pi pi-history"></i>
                </button>
                <button class="ai-icon-btn" (click)="toggle()" type="button" aria-label="Cerrar">
                    <i class="pi pi-times"></i>
                </button>
            </div>
        </div>

        <!-- Historial de conversaciones -->
        <div class="ai-history" *ngIf="showHistory">
            <div class="ai-history-title">Conversaciones</div>
            <div class="ai-history-empty" *ngIf="!conversaciones.length">Aún no tienes conversaciones guardadas.</div>
            <button class="ai-history-item" *ngFor="let cv of conversaciones"
                    [class.active]="cv.id === conversationId" (click)="abrirConversacion(cv.id)" type="button">
                <i class="pi pi-comment"></i>
                <span>{{ cv.title || 'Conversación' }}</span>
            </button>
        </div>

        <!-- Bloqueo por permiso: el botón/panel aparece, pero el chat queda inhabilitado -->
        <div class="ai-blocked" *ngIf="!puedeUsarIa">
            <div class="ai-blocked-orb">
                <i class="pi pi-lock"></i>
            </div>
            <h4>Inteligencia artificial no disponible</h4>
            <p>No cuentas con el permiso para usar la inteligencia artificial. Solicítaselo a un administrador de tu empresa.</p>
        </div>

        <div class="ai-messages" #scrollArea *ngIf="!showHistory && puedeUsarIa">

            <div class="ai-welcome" *ngIf="!messages.length && !thinking">
                <div class="ai-welcome-orb">
                    <svg viewBox="0 0 24 24" width="30" height="30" fill="white" aria-hidden="true">
                        <path d="M12 2l1.9 6.1L20 10l-6.1 1.9L12 18l-1.9-6.1L4 10l6.1-1.9L12 2z"/>
                        <path d="M19 14l.9 2.6L22.5 17.5l-2.6.9L19 21l-.9-2.6-2.6-.9 2.6-.9L19 14z" opacity="0.85"/>
                    </svg>
                </div>
                <h4>Hola 👋</h4>
                <p>Pregúntame por tus ventas, cobros o caja, en lenguaje natural.</p>
                <div class="ai-chips">
                    <button *ngFor="let s of suggestions" (click)="sendSuggestion(s)" type="button">{{ s }}</button>
                </div>
            </div>

            <div *ngFor="let m of messages"
                 class="ai-msg"
                 [class.ai-msg-user]="m.role === 'user'"
                 [class.ai-msg-error]="m.error">
                <div class="ai-bubble" *ngIf="m.role === 'user'">{{ m.content }}</div>

                <div class="ai-bubble ai-bubble-rich" *ngIf="m.role !== 'user'">
                    <div [innerHTML]="m.html || m.content"></div>

                    <!-- KPIs -->
                    <div class="ai-kpis" *ngIf="m.payload?.kpis?.length">
                        <div class="ai-kpi" *ngFor="let k of m.payload.kpis">
                            <span class="ai-kpi-label">{{ k.etiqueta }}</span>
                            <span class="ai-kpi-value">{{ k.valor }}</span>
                            <span class="ai-kpi-delta" *ngIf="k.delta"
                                  [class.neg]="k.delta.trim().startsWith('-')">{{ k.delta }}</span>
                        </div>
                    </div>

                    <!-- Gráfico -->
                    <div class="ai-chart" *ngIf="m.payload?.grafico && m.chartData">
                        <div class="ai-block-title" *ngIf="m.payload.grafico.titulo">{{ m.payload.grafico.titulo }}</div>
                        <p-chart [type]="m.payload.grafico.tipo" [data]="m.chartData"
                                 [options]="m.chartOptions" height="180px"></p-chart>
                    </div>

                    <!-- Tabla -->
                    <div class="ai-table-wrap" *ngIf="m.payload?.tabla as t">
                        <div class="ai-block-title" *ngIf="t.titulo">{{ t.titulo }}</div>
                        <table class="ai-table">
                            <thead>
                                <tr><th *ngFor="let c of t.columnas">{{ c }}</th></tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let fila of t.filas">
                                    <td *ngFor="let celda of fila">{{ celda }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="ai-table-note" *ngIf="t.totalFilas && t.totalFilas > t.filas.length">
                            Mostrando {{ t.filas.length }} de {{ t.totalFilas }}
                        </div>
                    </div>

                    <!-- Acciones -->
                    <div class="ai-actions" *ngIf="m.payload?.acciones?.length">
                        <button *ngFor="let a of m.payload.acciones" (click)="irAAccion(a.ruta)" type="button">
                            {{ a.label }} <i class="pi pi-arrow-right"></i>
                        </button>
                    </div>

                    <!-- Preguntas de seguimiento -->
                    <div class="ai-followups" *ngIf="m.payload?.sugerencias?.length">
                        <button *ngFor="let s of m.payload.sugerencias" (click)="sendSuggestion(s)"
                                [disabled]="thinking" type="button">{{ s }}</button>
                    </div>

                    <!-- Feedback 👍/👎 -->
                    <div class="ai-feedback" *ngIf="m.messageId && !m.error">
                        <button (click)="darFeedback(m, 1)" [class.on]="m.feedback === 1"
                                [disabled]="m.feedback" type="button" aria-label="Útil"><i class="pi pi-thumbs-up"></i></button>
                        <button (click)="darFeedback(m, -1)" [class.on]="m.feedback === -1"
                                [disabled]="m.feedback" type="button" aria-label="No útil"><i class="pi pi-thumbs-down"></i></button>
                        <span class="ai-feedback-thanks" *ngIf="m.feedback">¡Gracias!</span>
                    </div>
                </div>
            </div>

            <div class="ai-thinking" *ngIf="thinking">
                <span class="ai-shimmer">{{ toolStatus || 'Pensando…' }}</span>
            </div>

        </div>

        <div class="ai-inputbar">
            <input [(ngModel)]="input"
                   (keyup.enter)="send()"
                   [disabled]="thinking || !puedeUsarIa"
                   [placeholder]="puedeUsarIa ? 'Pregunta lo que quieras…' : 'Sin permiso para usar la IA'"
                   maxlength="2000" />
            <button class="ai-send" (click)="send()" [disabled]="!input.trim() || thinking || !puedeUsarIa" type="button" aria-label="Enviar">
                <i class="pi pi-arrow-up"></i>
            </button>
        </div>

    </div>
</div>
